import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Colors, Space, TextStyles } from '../../types';

export const Form: ComponentStyleConfig = {
  baseStyle: {
    helperText: {
      color: Colors.TEXT_SUBDUED,
      '&': { apply: `textStyles.${TextStyles.P3}` },
      mt: 0,
      mb: Space['2XS'],
      '&:last-child': {
        mt: Space['2XS'],
      },
    },
    requiredIndicator: {
      color: Colors.TEXT_ERROR,
    },
    container: {
      _notFirst: { mt: Space.MD },
    },
  },
  parts: [],
};
